module.exports = __webpack_public_path__ + "static/img/vibrate.1d1e449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate.jpg
// module id = A/sc
// module chunks = 0